import { Component, CUSTOM_ELEMENTS_SCHEMA, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@skylab-angular-shared/pipes';
import { TextValueAccessorDirective, ValidateDirective } from '@skylab-angular-shared/ui';
import { ModelBase } from '@skylab-shared/core';
import { DocumentItemModel } from '@skylab-shared/dataModel';
import { Mutable, PickByType, RecursiveDiff } from '@skylab-shared/types';

@Component({
    selector: 'skl-document-item-text-input-cell',
    template: `
		<ins-form-field
			class="no-boundary">
			<ins-input
				[placeholder]="'ui.placeholders.empty' | translate"
				[disabled]="adjusted"
				[(ngModel)]="entity[entityPropertyName]"
				[sklValidate]="entityPropertyName + '.' + entity.sun">
			</ins-input>
		</ins-form-field>
	`,
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [TextValueAccessorDirective, FormsModule, ValidateDirective, TranslatePipe]
})
export class DocumentItemTextInputCellComponent {
	@Input({required: true}) public entity!: DocumentItemModel;
	@Input({required: true}) public entityPropertyName!: keyof PickByType<Omit<Mutable<RecursiveDiff<DocumentItemModel, ModelBase>>, 'id'>, string>;
	@Input() public adjusted = false;
}
